module.exports = __webpack_public_path__ + "static/media/epam.9af17554.png";